import React from "react";
import { components, ControlProps } from "react-select";

import { SelectOption } from "../Select/Select.types";

export const CompactControlComponent = ({
    children,
    className,
    ...props
}: ControlProps<SelectOption>) => {
    const { selectProps } = props;

    return (
        <components.Control
            {...props}
            className={[
                className,
                "select-control",
                selectProps.isSearchable ? "select-control--searchable" : null,
            ]
                .filter(Boolean)
                .join(" ")}
        >
            {children}
        </components.Control>
    );
};

export default {};
